<template>
  <div class="lib__card lib__bg-white">
    <div class="lib__card__content">
      <div class="lib__card__icon lib__card__icon__small">
        <img alt="Night" :src="require('@ores/css-library/assets/img/icons/moon.svg')" v-if="!isGas && isNight" />
        <img alt="Day" :src="require('@ores/css-library/assets/img/icons/sun.svg')" v-else />
      </div>
      <div class="lib__card__inner-content">
        <h3 class='lib__no-margin'>{{ meterRegisterDirection }} <span class='lib__text-small lib__text-weight-500'>{{ gasMeterType }}</span></h3>
        <div class='lib__text-small lib__text-gray-600' v-if="!isGas">
          <span>{{ isNight ? $t('common.meterRegister.night') : $t('common.meterRegister.day') }}</span>
        </div>
        <div>
          <h3 v-if="readonly">{{ index }}</h3>
          <MaskedTextBox
            :label="$t('common.meterRegister.inputLabel')"
            v-model="index"
            mask='######'
            pattern='^\d{1,6}$'
            :placeholder="isGas ? 'm³' : 'kWh'"
            required
            v-else
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Prop, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Register } from '@/models/prosumer-declaration'
import { RegisterDirection } from '@/models/common'

@Component
export default class RegisterBox extends Vue {
  @Prop({ required: true }) public readonly value!: Register
  @Prop({ type: Boolean, required: true }) public readonly isGas!: boolean
  @Prop({ type: Boolean, required: false, default: false }) public readonly readonly!: boolean


  get meterRegisterDirection(): string {
    return this.value.direction === RegisterDirection.Production ?
      this.$t('common.meterRegister.production').toString() :
      this.$t('common.meterRegister.consumption').toString()
  }

  get gasMeterType(): string {
    switch (this.value.code) {
      case 'ANALOG': return this.$tc('common.meterRegister.analog')
      case 'DIGITAL': return this.$tc('common.meterRegister.digital')
      default: return ''
    }
  }

  get isNight(): boolean {
    return this.value.isNight
  }

  get index(): string {
    return this.value.value ?? ''
  }

  set index(val: string) {
    if (this.readonly) {
      return
    }

    this.$emit('input', val)
  }
}
</script>
